import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-6CYZML6B75";

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
  console.log("Google Analytics initialized");
};

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
